import React from 'react';
import { IMAGES } from 'src/shared/utils/appConstant';
import { IOT_STRINGS, cardDataNetworkManagement } from 'src/shared/utils/string';
import IOTServicePage from './IOTServicePage';

const NetworkManagementSystem: React.FC = () => {
  return (
    <IOTServicePage
      title={IOT_STRINGS.NETWORK_MANAGEMENT_SYSTEM}
      backgroundImage={IMAGES.NETWORK_MANAGEMENT_BANNER}
      cardData={cardDataNetworkManagement}
    />
  );
};

export default NetworkManagementSystem;